import FullScreenPage from "./FullScreenPage";

export default function UnknownPage() {
    return <FullScreenPage title="404" subtitle="Page not found" />
}